export const DEFAULT_ICON =
  'https://images.togetherwith.co.uk/Default-icon.png';
export const SAINSBURYS_LOGO_ICON =
  'https://images.togetherwith.co.uk/logo-sainsburys.svg';
export const FACEBOOK_ICON = 'img/facebook.svg';
export const TWITTER_ICON = 'img/twitter.svg';
export const YOUTUBE_ICON = 'img/youtube.svg';
export const INSTAGRAM_ICON = 'img/instagram.svg';
export const PINTEREST_ICON = 'img/pinterest.svg';
export const FLICKR_ICON = 'img/flickr.svg';
export const APP_STORE_ICON = 'img/appstore.svg';
export const GOOGLE_PLAY_ICON =
  'img/google-play-badge.png';
export const BECOME_A_SUPPLIER =
  'img/footer_image_compressed.png';
export const QUERY_APP_ICON =
  'img/queryapp-icon-v2.svg';
export const QUERY_APP_DEVICES_DESKTOP =
  'img/queryapp-devices-desktops-v2.svg';
export const QUERY_APP_DEVICES_TABLET =
  'img/queryapp-devices-tablet-v2.svg';
export const QUERY_APP_DEVICES_MOBILE =
  'https://images.togetherwith.co.uk/queryapp-devices-mobile-v2.svg';
export const REGISTER_ILLUSTRATION_ICON =
  'img/register-illustration-v2.svg';
export const ALL_APPS_ILLUSTRATION_ICON =
  'img/allapps-illustration-v2.svg';
export const FAVOURITES_ILLUSTRATION_ICON =
  'img/favourites-illustration-v2.svg';
export const DEVICE_COMBINATION =
  'https://images.togetherwith.co.uk/device-combination.png';
export const ACCOUNTS_ICON =
  'https://images.togetherwith.co.uk/account-icon.svg';
export const QUESTION_MARK_ICON =
  'https://images.togetherwith.co.uk/question-mark-icon.svg';
